<template>
    <modal-component v-model="modelValue">
        <div class="w-max mt-2 max-w-xs lg:max-w-max">
            <!-- Message -->
            <div class="text-lg text-secondary mb-8">
                {{ message }}
            </div>

            <!-- Button -->
            <div class="flex justify-end">
                <button
                    class="
                        font-medium
                        text-white
                        border-2 border-primary
                        text-center text-sm
                        py-2
                        px-3.5
                        cursor-pointer
                        rounded-full
                        bg-primary
                        hover:bg-secondary
                        hover:text-white
                        hover:border-secondary
                        focus:outline-none
                        transition-colors
                        duration-500
                    "
                    @click="confirm"
                >
                    Confirm
                </button>
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "@/Components/Modal";

export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        message: {
            type: String,
            default: "Are you sure?",
        },
    },
    components: {
        ModalComponent,
    },
    methods: {
        confirm() {
            this.$emit("confirm");
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>
